import 'react-loading-skeleton/dist/skeleton.css'

import Skeleton from 'react-loading-skeleton'
import { View } from '../../compiler'
import { typoStyles } from '../../constants'
import MarkdownText from '../MarkdownText'

const TitleDescription = ({
  title,
  description,
  containerStyle = { marginHorizontal: 40 },
  withH1,
  isLoading
}) => {
  return (
    <View style={containerStyle}>
      <MarkdownText
        style={[
          { display: 'block' },
          typoStyles.H2Black,
          { lineHeight: 1.2, marginBottom: 4 },
          withH1 && typoStyles.H1Black
        ]}
      >
        {isLoading ? <Skeleton width={200} /> : title}
      </MarkdownText>
      <MarkdownText
        style={[{ display: 'block' }, typoStyles.T1Black, { lineHeight: 1.2 }]}
      >
        {isLoading ? <Skeleton /> : description}
      </MarkdownText>
    </View>
  )
}

export default TitleDescription
